const TOKEN_EXPIRES_IN = 15 * 24 * 60 * 60 * 1000
const TOKEN_EXPIRES_AT_KEY = 'tokenExpiresAt'

export function setTokenExpiresAt() {
  window.localStorage.setItem(TOKEN_EXPIRES_AT_KEY, String(Date.now() + TOKEN_EXPIRES_IN))
}

export function removeTokenExpiresAt() {
  window.localStorage.removeItem(TOKEN_EXPIRES_AT_KEY)
}

export function isTokenExpired() {
  const token = window.localStorage.getItem('token')
  const expiresAt = Number(window.localStorage.getItem(TOKEN_EXPIRES_AT_KEY))

  if (!token || !expiresAt) {
    return false
  }

  return Date.now() >= expiresAt
}
